import { type ReactElement } from 'react'
import { Typography } from '@front/model'
import { Skeleton } from '@mantine/core'
import { type AvatarSize, AvatarSkeleton } from 'app/components/AvatarBlurhash'
import { TListItem } from './ListItem'

type Props = {
  avatarSize?: AvatarSize
}
export const LoadingEntityListItem = ({ avatarSize = 'md' }: Props): ReactElement => {
  return (
    <TListItem leftSection={<AvatarSkeleton size={avatarSize} />}>
      <Skeleton h={Typography.line.lg} w='100%' />
    </TListItem>
  )
}
